const MAX_DIMENSION = 2048;
const QUALITY = 0.85;
const RESIZE_THRESHOLD = 2 * 1024 * 1024; // 2MB

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      resolve(img);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

/**
 * Resize image if over threshold. Skips HEIC (Canvas can't decode it reliably).
 */
export async function resizeImageIfNeeded(file) {
  // HEIC/HEIF: Canvas API has limited browser support for decoding these.
  // Let backend handle them as-is since they're already efficiently compressed.
  if (file.type === "image/heic" || file.type === "image/heif") {
    return file;
  }

  if (file.size <= RESIZE_THRESHOLD) {
    return file;
  }

  const img = await loadImage(file);
  let { width, height } = img;

  if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
    const ratio = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(img, 0, 0, width, height);

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", QUALITY)
  );

  return new File([blob], file.name.replace(/\.[^.]+$/, ".jpg"), {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
}
